import React, { useState, useEffect, useRef } from "react";
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faBarcode, faFilter } from "@fortawesome/free-solid-svg-icons"; // import edit e trash icon
import DeleteConfirmation from "./../../components/DeleteConfirmation.js";
import "./../../App.css";
import localeToPortuguese from "./../../components/funcoes_gerais.js";
import { useAlert } from './../../components/AlertContext.jsx';
import OkModal from "./../../components/OkModal.js";
import dayjs from 'dayjs';
import { useHeader } from './../../components/HeaderContext';
import qs from 'qs';
import { Select, DatePicker } from 'antd';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import useAuth from "./../../hooks/useAuth.js";
import { encryptId } from './../../components/utils_react.jsx'


// React Notification
import { NotificationManager } from 'react-notifications';

const PurchaseOrders = () => {

    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const ReturnPage = "/purchase_orders";

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Purchase Orders");
    }, [setHeader]);

    const [loading, setLoading] = useState(false);

    const [type, setType] = useState(null);
    const [id, setId] = useState(null);         // usado no dialogo de confirmar delete e voltar
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);

    const { triggerAlert } = useAlert();

    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    // Handle the displaying of the modal based on type and id
    const showDeleteModal = (type, id) => {
        setId(id);
        console.log(id);
        setDeleteMessage(`Are you sure you want to delete the record: ${type}?`);

        setDisplayConfirmationModal(true);
    };

    // Hide the modal
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    };

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };

    const columns = [
        {
            field: 'actions',
            headerName: '',
            disableColumnMenu: true,
            width: 80,
            renderCell: (params) => (
                <div>
                    <FontAwesomeIcon icon={faEdit} style={{ cursor: 'pointer', marginRight: '8px' }} onClick={() => EditRow(params.row.id)} />
                    {/*    <FontAwesomeIcon icon={faTrash} style={{ cursor: 'pointer' }} onClick={() => deleteRow(params.row.os, params.row.id)} />  */}
                </div>
            ),
        },
        { field: 'purchase_header_id', headerName: 'ID', disableColumnMenu: true },
        { field: 'purchase_no', headerName: 'Purchase No', headerClassName: 'super-app-theme--header', width: 160, disableColumnMenu: true },
        { field: 'supplier_code', headerName: 'Supplier', width: 100, disableColumnMenu: true },
        { field: 'supplier_name', headerName: 'Name', width: 300, disableColumnMenu: true },
        {
            field: 'state',
            headerName: 'State',
            width: 120,
            disableColumnMenu: true,
            renderCell: (params) => {
                const state = optionsState.find(option => option.value === params.value);
                return <span>{state ? state.label : params.value}</span>;
            }
        },
        { field: 'document_date', headerName: 'Doc Date', width: 120, valueFormatter: document_date => document_date ? dayjs(document_date).format('YYYY-MM-DD') : '', disableColumnMenu: true },

    ]

    const optionsState = [
        { value: 1, label: 'Draft' },
        { value: 2, label: 'Processing' },
        { value: 3, label: 'Completed' },
        { value: 4, label: 'Closed' }
    ]


    function EditRow(param1) {
        const encryptedId = encryptId(param1);
        navigate(`/purchase_orders_edit/${encryptedId}`);
    }


    function deleteRow(param1, param2) {
        showDeleteModal(param1, param2)
    }


    const handleSubmitDelete = async (id) => {
        try {
            setDisplayConfirmationModal(false);
            await axiosPrivate.get(`${baseURL}/ordens_allowdelete/` + id)
                .then(res => {

                    let total_count = res.data.total_count;
                    console.log("total_count: ", res.data.total_count);

                    if (total_count >= 1) {
                        handleShowOkModal("Ordem de Serviço com Operações ou com Materiais. Registo não pode ser apagado!", "error")
                    }
                    else {
                        try {
                            axiosPrivate.delete(`${baseURL}/ordens/` + id)
                                .then(res => {

                                    let message = `Registo eliminado!`;
                                    triggerAlert(message, 'success');

                                    fetchPurchaseOrder();
                                })
                                .catch(err => console.log(err))
                        } catch (error) {
                            console.error('Error fetching data:', error);
                        }
                    }
                })
                .catch(err => console.log(err))
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };




    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setPageSize] = useState(20);
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState("purchase_no");
    const [sortOrder, setSortOrder] = useState("desc");

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 20, });



    // Calculate the date for 1st January of the current year minus 10 years
    const initialDate = dayjs().subtract(10, 'year').startOf('year');

    //console.log("initialDate: ", initialDate);

    //const [startDate, setStartDate] = useState(dayjs('2020/01/01'));
    const [startDate, setStartDate] = useState(initialDate);
    const [endDate, setEndDate] = useState('');

    //para guardar os valores dos campos
    const [filterData, setFilterData] = useState({
        purchase_no: '',
        supplier_name: ''
    })




    // Fetch initial data for select elements and set initial filter state
    useEffect(() => {
        const fetchData = async () => {
        };

        fetchData();
    }, []); // Runs only once on component mount





    useEffect(() => {


        console.log("4 useEffect fetchOS page", filterData);

        fetchPurchaseOrder();

        return () => {
            console.log("clean up")
        }
    }, [page, limit, sortField, sortOrder]);





    const fetchPurchaseOrder = async () => {

        const queryString = qs.stringify(filterData);

        console.log("purchase_orders.js > fetchPurchaseOrder > filterData: ", filterData);

        console.log("purchase_orders.js > fetchPurchaseOrder > queryString: ", queryString);

        try {

            setLoading(true);

            await axiosPrivate.get(`${baseURL}/purchase_orders_page?page=${page + 1}&limit=${limit}&sortfield=${sortField}&sortorder=${sortOrder}&${queryString}`)

                .then(result => {
                    console.log(result.data.result);

                    // return ok
                    if (result.status === 200) {
                        setRows(result.data.result.map(row => ({ id: row.purchase_header_id, ...row })));
                        //setRows(result.data.rows);
                        setTotalRows(result.data.total_count);

                        setLoading(false);
                    }
                    else {
                        alert(result.data.Error);
                    }
                }).catch(err => console.log(err))
        } catch (error) {
            console.error('Failed to fetch products:', error);
            setLoading(false);
        }
    };







    function handlePageChange(newPage, newPageSize) {
        console.log("handlePageChange: ", newPage, " ", newPageSize, " atual limite: ", limit);

        if (newPageSize === limit) {
            setPage(newPage);
            setPaginationModel({ ...paginationModel, page: newPage, pageSize: limit });
            console.log("paginationModel: ", paginationModel);
        }
        else {
            setPage(0);
            setPageSize(newPageSize);
            console.log("mudou page size: ", paginationModel);
            setPaginationModel({ ...paginationModel, page: 0, pageSize: newPageSize });
        }
    }

    // Handler for sorting
    //const handleSortModelChange = (newSortModel) => {
    function handleSortModelChange(newSortModel) {
        const { field, sort } = newSortModel[0] || {};
        console.log("SortModel:", field, " ", sort);

        if (field) {
            setPage(0);
            setSortField(field);
            setSortOrder(sort);
            console.log("Field Page:", page);
        }
        else {
            setSortField("purchase_no");
            setSortOrder("desc");
        }

        setPaginationModel({ ...paginationModel, page: 0 });
    };



















    const handleBtnSearch = async () => {
        console.log("Search button clicked with values:");
        console.log("filterData: ", filterData);

        await fetchPurchaseOrder();
        //await fetchStockSeleccionado();
    };




    return (
        <div className="mt-2">


            <div className="row w-100 mb-2">

                {/*
                <div className="col-1 d-flex flex-column justify-content-end">
                    <div className="mt-auto">
                        <button type="button" className="btn btn-outline-success btn-sm mb-2" id="new" onClick={handleBtnNew}>+ New</button>
                    </div>
                </div>
*/}

                <div className="col-1 d-flex flex-column justify-content-end">
                    <label htmlFor="purchase_no" className="form-label app_font1 me-2"> Purchase No </label>
                    <input
                        type="text"
                        //placeholder="Enter wildcard"
                        value={filterData.purchase_no}
                        onChange={(e) => setFilterData({ ...filterData, purchase_no: e.target.value })}
                    />
                </div>


                <div className="col-2 d-flex flex-column justify-content-end">
                    <label htmlFor="supplier_name" className="form-label app_font1 me-2"> Supplier Name </label>
                    <input
                        type="text"
                        //placeholder="Enter wildcard"
                        value={filterData.supplier_name}
                        onChange={(e) => setFilterData({ ...filterData, supplier_name: e.target.value })}
                    />
                </div>





                <div className="col-1 d-flex flex-column justify-content-end">
                    <div className="mt-auto">
                        <button type="button" className="btn btn-outline-success btn-sm mb-1 " id="search" onClick={handleBtnSearch}> Search </button>
                    </div>
                </div>



            </div>






            <div style={{ width: '90%', position: 'relative' }}>
                <DataGrid

                    slotProps={{
                        pagination: {
                            showFirstButton: true,
                            showLastButton: true,
                        },
                    }}

                    page={page - 1}
                    rows={rows}
                    columns={columns}
                    rowHeight={40}
                    disableRowSelectionOnClick={true}
                    autoHeight={true}
                    paginationMode="server"
                    sortingMode="server"
                    density="compact"
                    rowCount={totalRows}
                    pagination

                    pageSizeOptions={[20, 40, 60]}

                    onCellClick={(params) => {
                        console.log("===cell click===", params);
                    }}

                    onPaginationModelChange={(params) => {
                        console.log("===page size===", params);
                        //console.log(params.page);
                        handlePageChange(params.page, params.pageSize);
                    }}

                    paginationModel={paginationModel}

                    initialState={{
                        pagination: { paginationModel: { page: 0, pageSize: 20 } },
                        // Hide column produto_id, the other columns will remain visible
                        columns: { columnVisibilityModel: { purchase_header_id: false } },

                    }}

                    onSortModelChange={handleSortModelChange}

                />
                <DeleteConfirmation showModal={displayConfirmationModal}
                    confirmModal={() => handleSubmitDelete(id)}
                    hideModal={hideConfirmationModal} type={type} id={id} message={deleteMessage} />

                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                />

                {loading && (
                    <div className="overlay">
                        <div className="loading-circle"></div>
                    </div>
                )}

            </div>
        </div>
    );
}

export default PurchaseOrders;
